/**
 * @function getDashboardConfiguration
 *
 * This function is used to unwrap and construct the dashboard configuration when given a dashboard name and GraphQL data.
 *
 * @param {string} dashboardName - The name of the dashboard you are embedding, as it is known on the back end.
 * @param {object} gdData - The data received from a GraphQL User.GoodDataClaim Query.
 *
 * @return {object} - An object representing the dashboard configuration.
 * Enabled tells you whether or not the dashboard exists for this institution and dashboard contains important
 * dashboard information like the name, project id, and dashboard id
 *
 * @example
 *
 *     getDashboardConfiguration("you_network_vs_edu", gdGQLData)
 */
export const getDashboardConfiguration = (
  dashboardName: string,
  gdData: any
) => {
  const dashboardUnwrapped =
    gdData &&
    gdData.user.goodDataClaim.dashboards.filter((dashboard: any) => {
      return dashboard.name === dashboardName;
    });
  const dashboardEnabled = dashboardUnwrapped && dashboardUnwrapped.length > 0;
  const dashboard = dashboardEnabled && dashboardUnwrapped[0];

  return {
    enabled: dashboardEnabled,
    dashboard: dashboard
  };
};
